/**
 * Connection Error Utilities - Helpers for sanitizing connection error messages
 */

// UUID pattern: 8-4-4-4-12 hex chars
const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

/**
 * Sanitizes connection error messages by replacing UUIDs with user-friendly text.
 *
 * Example:
 * - Input: "Connection 9613139c-d532-4980-aa6f-36759f0faffa is not active. Connect first."
 * - Output: "Connection is not active. Connect first."
 */
export function sanitizeConnectionErrorMessage(message: string): string {
  // Replace "Connection <UUID>" with just "Connection"
  let sanitized = message.replace(/Connection\s+[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, 'Connection');

  // Replace any remaining standalone UUIDs with "..."
  sanitized = sanitized.replace(UUID_PATTERN, '...');

  return sanitized;
}
